import { z } from "zod/v4";

import { ExperienceKeyMetricDtoSchema } from "../../../dtos/experience-key-metrics";

export const GetExperienceKeyMetricsResponseBodySchema = z.object({
  experienceKeyMetrics: ExperienceKeyMetricDtoSchema.array(),
});
export type GetExperienceKeyMetricsResponseBodyType = z.infer<
  typeof GetExperienceKeyMetricsResponseBodySchema
>;

export const GetExperienceKeyMetricsRequestPathParamsSchema = z.object({
  experienceId: z.uuid(),
});
export type GetExperienceKeyMetricsRequestPathParamsType = z.infer<
  typeof GetExperienceKeyMetricsRequestPathParamsSchema
>;
